export default {
  contracts: {
    activeContracts: 'စာခ်ဳပ္သက္တမ္းရွိသည္',
    productsAndHours: 'အေထာက္အပံ႔ေပးရန္ နာရီမ်ားက်န္ရွိသည္',
    supported: 'အေထာက္အပံ႔ ေပးသည္',
    notSupported: 'အေထာက္အပံ႔ မေပးပါ',
    contact: 'မန္ေနဂ်ာ'
  },
  states: {
    OPEN: 'ဖြင္႔သည္',
    AWAITING_REPLY: 'အၾကာင္းျပန္ျခင္း ေစာင္႔ဆုိင္းေနသည္',
    CLOSED: 'ပိတ္ခဲ႔သည္',
    FEEDBACK_REQUIRED: 'တုံ႔ျပန္ခ်က္ လုိအပ္သည္',
    onlyRequired: 'လုိအပ္သည္႔ လုပ္ေဆာင္ခ်က္မ်ား သာျပသသည္',
    onlyWorkRequests: 'အလုပ်တောင်းဆိုမှု အတည်ပြုချက်များကိုသာ ပြသပါ။'
  },
  common: {
    New: 'အသစ္',
    Open: 'ဖြင္႔သည္',
    Pending: 'စိစစ္ဆဲ',
    Closed: 'ပိတ္ခဲ႔သည္',
    create: 'ဖန္တီးသည္',
    cancel: 'ပယ္ဖ်က္သည္',
    goBack: 'ေနာက္သုိ႔ ျပန္သြားသည္',
    close: 'ပိတ္သည္',
    goToMain: 'ပင္မစာမ်က္နွာသုိ႔ ျပန္သြားသည္'
  },
  property: {
    name: 'ကုိယ္႔နွင္႔ဆုိင္ေသာ ဥစၥာပစၥည္းမ်ား',
    allProperties: 'ဥစၥာပစၥည္းမ်ားအားလုံး',
    selectProperty: 'မိမိ ပစၥည္းကိုေရြးခ်ယ္ပါ'
  },
  product: {
    name: 'ထုတ္ကုန္',
    allProducts: 'ထုတ္ကုန္မ်ားအားလုံး',
    selectProduct: 'ထုတ္ကုန္ေရြးခ်ယ္ပါ',
    goBack: 'ေနာက္သုိ႔ျပန္သြားသည္',
    noProducts: 'ထုတ္ကုန္မရွိ'
  },
  chart: {
    chooseMonth: 'လ ေရြးပါ',
    noData: 'လက္ရွိအခ်ိန္ကာလအတြက္ ေဖာ္ျပစရာအေၾကာင္းအရာမရွိပါ'
  },
  navigation: {
    main: 'ပင္မ',
    interactions: 'လက္မွတ္',
    contracts: 'စာခ်ဳပ္',
    signOut: 'အေကာင္႔ထြက္သည္'
  },
  tickets: {
    createNewTitle: 'လက္မွတ္အသစ္ဖန္တီးသည္',
    title: 'ေခါင္းစဥ္',
    noTickets: 'လက္ရွိကာလ အတြက္ လက္မွတ္မရွိပါ',
    search: 'ရွာေဖြရန္',
    createNew: 'အသစ္ဖန္တီးရန္',
    reopenOrDisagree: 'သေဘာမတူပါ',
    escalation: 'လြတ္ေျမာက္သည္',
    reason: 'အေၾကာင္းျပခ်က္',
    reopen: 'သေဘာမတူပါ',
    escalate: 'လြတ္ေျမာက္သည္',
    opinionTitle: 'သင္႔ထင္ျမင္ခ်က္သည္ ကၽြန္ပ္တို႔အတြက္အေရးၾကီးသည္!',
    opinionBody: 'ကၽြန္ပ္တို႔၏ဝန္ထမ္းမ်ားကို ေဝဖန္ေပးပါ',
    time: 'ေျဖရွင္းသည္႔အခ်ိန္',
    qualification: 'နည္းပညာအရည္အေသြး',
    communication: 'ဆက္သြယ္ေျပာဆုိမွဳ အရည္အေသြး',
    sendFeedback: 'တုံ႔ျပန္ခ်က္ေပးပို႔သည္',
    leaveFeedback: 'တုံ႔ျပန္ခ်က္ ခ်န္ခဲ႔သည္',
    close: 'ပိတ္သည္',
    alreadyHasFeedback: 'လက္မွတ္တြင္ တုံ႔ျပန္ခ်က္ရွိသည္',
    feedbackHasBeenSent: 'တု႔ံျပန္ခ်က္ ေပးပုိ႔ျပီးပါျပီ',
    ticketHasBeenReopened: 'လက္မွတ္ကုိ ျပန္ဖြင္႔ျပီးပါျပီ',
    ticketHasBeenEscalated: 'လက္မွတ္ကုိ လြတ္ေျမာက္ျပီးပါျပီ',
    comment: 'ထင္ျမင္ခ်က္',
    keyPlaceholder: 'စာရိုက်ပါ။',
    approve: 'လက်မခံပါ။',
    reject: 'ငြင်းပယ်ပါ။',
    workRequestOnContractNotification:
      'လေးစားအပ်ပါသော {{fullName}}၊\n\nလောလောဆယ်တွင်၊ သင့်ပံ့ပိုးမှုစာချုပ်တွင် တန်ဖိုးထပ်ထည့်ထားသော ဝန်ဆောင်မှု {{hoursInSupportContract}} နာရီ ရှိပါသည်။\nလက်မှတ် {{workRequestId}} ပြီးမြောက်ရန် {{hoursRequested}} နာရီ လိုအပ်ပါမည်။ \n\nအထက်ပါလုပ်ငန်းအတွက် လက်ကျန်ထဲမှ နာရီများကို နုတ်ယူခြင်းကို အတည်ပြုပေးပါ။\nကျေးဇူးတင်ပါတယ်\n\nလေးစားစွာဖြင့်\n{{author}}',
    workRequestChargeableNotification:
      'လေးစားအပ်ပါသော {{fullName}}၊\n\nဤလုပ်ငန်းသည် ဝန်ဆောင်မှုတွင် မပါဝင်ပါ သို့မဟုတ် စာချုပ်အရ အာမခံချက်မရှိပါ။ ကျွန်ုပ်တို့သည် အချိန်ဇယားဆွဲပြီး ကူညီရန် ပျော်ရွှင်နေပါမည်။ တောင်းဆိုချက် {{workRequestId}} ကို ပြီးမြောက်ရန် {{hoursRequested}} နာရီ ခန့်မှန်းပါသည်။\n\nဤတောင်းဆိုချက်ကို ပြီးမြောက်ရန် ကုန်ကျစရိတ်မှာ {{amount}} ဖြစ်သည်။\nဤကမ်းလှမ်းချက်သည် ပြဿနာဖြစ်ပွားသည့်နေ့မှ 7 ရက်အတွင်း အကျုံးဝင်ပါသည်။ \nအမှန်တကယ်သုံးစွဲသည့်အချိန်သည် မူရင်းကိုးကားချက်ထက် ကျော်လွန်ပါက၊ အတည်ပြုချက်အတွက် တောင်းဆိုသူထံ အပိုထပ်ဆောင်းတောင်းဆိုချက်ပုံစံကို ပေးပို့ပါမည်။ ခန့်မှန်းအချိန်သည် မူရင်းကိုးကားချက်ထက် နည်းပါက မူရင်းကိုးကားချက်ကို ပယ်ဖျက်မည်ဖြစ်ပြီး ပြန်လည်ပြင်ဆင်ထားသော ကိုးကားချက်ပါရှိပါမည်။ ပို့ပါမည်။\n\nနောက်ထပ်အလုပ်နှင့် အခကြေးငွေကို အတည်ပြုပေးပါ။\n\nလေးစားစွာဖြင့်\n{{author}}',
    workRequestCommentRequired:
      'အလုပ်တောင်းဆိုမှုကို ငြင်းပယ်ခြင်းအတွက် အကြောင်းပြချက်တစ်ခုပေးပါ။'
  },
  severity: {
    name: 'ျပသနာအဆင္႔',
    0: 'ပုံမွန္',
    1: 'ျမင္႔မားသည္',
    2: 'အႏၱရာယ္ရွိသည္'
  },
  forms: {
    password: 'လွ်ဳိ႕ဝွက္ဂဏန္း',
    confirmPassword: 'လွ်ဳိ႕ဝွက္ဂဏန္းအတည္ျပဳသည္',
    passwordsDoNotMatch: 'လွ်ဳိ႕ဝွက္ဂဏန္း မတူညီပါ',
    updatePassword: 'လွ်ဳိ႕ဝွက္ဂဏန္း အသစ္သတ္မွတ္ပါ',
    askRestore: 'လွ်ဳိ႕ဝွက္ဂဏန္းအသစ္အတြက္ ေတာင္းဆုိပါ',
    remember: 'မွတ္မိသည္',
    restorePassword: 'လွ်ဳိ႕ဝွက္ဂဏန္း ျပန္ေခၚသည္',
    signIn: 'အေကာင္႔ဝင္သည္'
  },
  transactions: {
    date: 'ေန႔',
    type: 'အမ်ိဳးအစား',
    comment: 'ထင္ျမင္ခ်က္',
    status: 'အေျခအေန',
    subject: 'အလုပ္အတြက္ ေတာင္းဆုိျခင္း',
    name: 'လုပ္ေဆာင္ခ်က္ အေၾကာင္းအရာမ်ား',
    hours: 'နာရီမ်ား',
    viewTransactions: 'လုပ္ေဆာင္ခ်က္မ်ားကို ၾကည္႔ရွဳ႕ျခင္း',
    types: {
      WORK_REQUEST: 'အလုပ္အတြက္ ေတာင္းခံျခင္း',
      CONTRACT_ACTIVATION: 'စာခ်ဳပ္သက္တမ္းရွိသည္',
      CONTRACT_EXPIRATION: 'စာခ်ဳပ္သက္တမ္းကုန္သည္',
      MANUAL_ADJUST_ADD: 'ကိုယ္တိုင္ညွိႏိုင္းျခင္း-ေပါင္းထည္႔သည္',
      MANUAL_ADJUST_DEDUCT: 'ကုိ္ယ္တုိင္ညွိႏိုုိင္းျခင္း - နွုတ္သည္',
      TRANSFER_PROPERTY: 'ပစၥည္းဥစၥာေျပာင္းေရႊ႕ျခင္း',
      TRANSFER_PRODUCT: 'ထုတ္ကုန္ေျပာင္းေရႊ႕ျခင္း'
    }
  },
  transactionDetail: {
    name: 'လုပ္ေဆာင္ခ်က္ အေသးစိတ္အခ်က္အလက္',
    num: 'အေရအတြက္',
    insertTime: 'ဖန္တီးသည္႔ ေန႔',
    requestorName: 'ဖန္တီးသူ နာမည္',
    subject: 'အေၾကာင္းအရာ',
    status: 'အေျခအေန',
    acceptTime: 'လက္ခံခဲ႔သည္႔အခ်ိန္',
    cancelTime: 'ပယ္ဖ်က္သည္႔အခ်ိန္',
    hours: 'နာရီမ်ား',
    hourType: 'နာရီ အမ်ိဳးအစားမ်ား',
    workText: 'အလုပ္ေဖာ္ျပခ်က္',
    plannedDate: 'စီစဥ္ထားသည္႔ေန႔'
  },
  statuses: {
    Approved: 'အတည္ျပဳခဲ႔သည္',
    Pending: 'စိစစ္ဆဲ',
    Cancelled: 'ပယ္ဖ်က္ခဲ႔သည္'
  },
  hoursTypes: {
    'Included in contract': 'စာခ်ဳပ္တြင္ပါဝင္သည္',
    'Installation hours': 'အင္စေတာေလးရွင္လုပ္သည္႔ နာရီမ်ား',
    'Preventative visit': 'တားဆီးကာကြယ္ျခင္း',
    Chargeable: 'ေငြေကာက္ခံျခင္း'
  },
  errors: {
    unknown: 'အမည္မသိ အမွား',
    1000: 'အမွားအတြက္ ေတာင္းဆုိသည္',
    1001: 'အမွားအတြက္ ေတာင္းဆုိသည္',
    1: 'လွ်ဳိ႕ဝွက္ ဂဏန္းမွားသည္',
    2: 'သတ္မွတ္ခ်ိန္ျပည္႔သည္',
    3: 'အမည္မသိ ပစၥည္း',
    4: 'အမည္မသိ ထုတ္ကုန္',
    7: 'အမည္မသိ တုံံ႔ျပန္မွဳ',
    8: 'တုံ႔ျပန္မွဳကုိ ပိတ္ခဲ႔သည္',
    11: 'စည္းကမ္းခ်ိဳးေဖာက္သည္',
    12: 'အမည္မသိေတာင္းခံျခင္း'
  }
}
